jQuery(document).ready(function($) {
  "use strict";

  const $container = $('#wishlist-container');

  const getHandleFromUrl = url => {
    const matches = url.match(/\/products\/([^?\/]+)/);
    return matches ? matches[1] : null;
  };

  const wishlist = {
    perPage: window.wishlistSettings?.perPage || 6,
    currentPage: window.wishlistSettings?.currentPage || 1,
    totalPages: window.wishlistSettings?.totalPages || 1,

    init() {
      this.load();
    },

    load() {
      const dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');
      const wishlistItems = dataUser.dataWishlist || [];

      $('#wishlist-loading').show();
      $container.html('');

      if (!Array.isArray(wishlistItems) || wishlistItems.length === 0) {
        $container.html('<p class="result-text">No products to wishlist. <a href="/collections/all">Return to Shop</a></p>');
        $('#wishlist-pagination').empty();
        $('#wishlist-loading').hide();
        return;
      }

      const uniqueWishlist = wishlistItems.filter((item, index, self) => {
        const handle = getHandleFromUrl(item.url);
        return self.findIndex(i => getHandleFromUrl(i.url) === handle) === index;
      });

      this.totalPages = Math.ceil(uniqueWishlist.length / this.perPage);
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      const itemsToRender = uniqueWishlist.slice(start, end);

      const htmlItems = [];

      const productPromises = itemsToRender.map(item => {
        const handle = getHandleFromUrl(item.url);
        return fetch(`/products/${handle}.js`)
          .then(res => {
            if (!res.ok) throw new Error('Product not found');
            return res.json();
          })
          .then(() => {
            const url = `/products/${handle}?view=handle`;
            return new Promise((resolve, reject) => {
              $.get(url, function(product) {
                const doc = new DOMParser().parseFromString(product, 'text/html');
                const itemHtml = doc.querySelector('.card-product-handle');

                if (itemHtml) {
                  itemHtml.classList.add('wishlisted');
                  const desc = itemHtml.querySelector('.cartProduct__desc');
                  const btncart = itemHtml.querySelector('.box-icon.addcart');
                  if (desc) desc.remove();
                  if (btncart) btncart.remove();
                  htmlItems.push(itemHtml.outerHTML);
                  resolve();
                } else {
                  reject('card-product-handle not found');
                }
              }).fail(() => reject('Failed to load view'));
            });
          })
          .catch(err => {
            console.error(`Error loading product ${item.url}:`, err);
            htmlItems.push(`<div class="items"><p>Failed to load product: ${item.url}</p></div>`);
          });
      });

      Promise.all(productPromises).then(() => {
        $container.html(htmlItems.join(''));
        $('#wishlist-loading').hide();
        events();
        this.renderPagination(this.currentPage, this.totalPages);
        this.bindPagination('.pagination-item[data-page]');
      });
    },

    renderPagination(currentPage, totalPages) {
      if (totalPages <= 1) return;

      let html = `
        <nav class="pagination-nav" role="navigation" aria-label="Pagination">
          <ul class="pagination-list" role="list">
      `;

      if (currentPage > 1) {
        html += `
          <li>
            <a href="#" data-page="${currentPage - 1}" class="pagination-item pagination-item-next pagination-item-arrow" aria-label="Previous page">
              <i class="icon icon-left"></i>
            </a>
          </li>
        `;
      }

      for (let i = 1; i <= totalPages; i++) {
        if (i === currentPage) {
          html += `
            <li>
              <span class="pagination-item pagination-item-current" aria-current="page" aria-label="Page ${i}">${i}</span>
            </li>
          `;
        } else {
          html += `
            <li>
              <a href="#" data-page="${i}" class="pagination-item" aria-label="Go to page ${i}">${i}</a>
            </li>
          `;
        }
      }

      if (currentPage < totalPages) {
        html += `
          <li>
            <a href="#" data-page="${currentPage + 1}" class="pagination-item pagination-item-prev pagination-item-arrow" aria-label="Next page">
              <i class="icon icon-right"></i>
            </a>
          </li>
        `;
      }

      html += `
          </ul>
        </nav>
      `;

      $('#wishlist-pagination').html(html);
    },

    bindPagination(selector) {
      $(selector).off('click').on('click', function(e) {
        e.preventDefault();
        const page = parseInt($(this).data('page'));
        wishlist.currentPage = page;
        wishlist.load();
      });
    },
  };

  function addcart() {
    $('#wishlist-container .addcart, #wishlist-container .btn-add-cart').each(function() {
      $(this).off('click').on('click', function () {
        let variantId = $(this).parents('.card-product').find('.colorItem.active').data('id');
        const quantity = 1;
        if (!variantId) {
          variantId = $(this).parents('.card-product').data('productid');
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: quantity,
            id: variantId
          },
          dataType: 'json',
          success: function() {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                $('.nav-cart .icon-cart').next().remove();
                $('.nav-cart .icon-cart').after('<span class="count-box text-button-small">'+cart.item_count+'</span>');
                $('.open-cart').trigger('click'); 
                setTimeout(function() {
                  $('.tf-minicart-recommendations').addClass('open');
                }, 800);
              });

          },
          error: function(err) {
            alert('Add to cart failed.');
            console.error(err);
          }
        });
      });
    });
  }

  function compare() {
    $('#wishlist-container .compare').each(function() {
      $(this).off('click').on('click', function () {
        const $card = $(this).closest('.card-product');
        const productId = $card.find('.colorItem.active').data('id') || $card.data('productid');
        const img = $card.find('.colorItem.active').data('img') || $card.find('.image-wrap img:first').attr('src');
        const url = $card.find('.image-wrap').attr('href') + (productId ? `?variant=${productId}` : '');

        if (!productId) return;

        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (!dataUser.randomId) {
          dataUser = {
            id: typeof customerId !== "undefined" ? customerId : "",
            randomId: themeName + products.generateRandomString(100),
            dataWishlist: [],
            dataCompare: []
          };
        }

        const exists = dataUser.dataCompare?.some(item => item.id == productId);

        if (exists) {
          dataUser.dataCompare = dataUser.dataCompare.filter(item => item.id != productId);
          $(`.tf-sidebar-compare .item[data-id="${productId}"]`).remove();
          $card.removeClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          if (!$('.tf-sidebar-compare .item').length) $('.tf-sidebar-compare.active').removeClass('active');;
        } else {
          dataUser.dataCompare = [...(dataUser.dataCompare || []), { id: productId, img, url }];
          $('.tf-sidebar-compare .content').append(`
            <div class="item" data-id="${productId}">
              <span class="remove"><span class="icon icon-close"></span></span>
              <a href="${url}" title=""><img src="${img}" alt=""></a>
            </div>`);
          $card.addClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip-delete');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          $('.tf-sidebar-compare').addClass('active');;
        }

        localStorage.setItem("dataUser", JSON.stringify(dataUser));
        S00801SidebarCompare.init();
      });
    });
  }

  function clickColors() {
    $('#wishlist-container .colorItem').each(function () {
      $(this).off('click').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
        const index = $(this).data('index');
        $('#wishlist-container .cartProduct__prices .price').eq(index).addClass('active').siblings().removeClass('active');
      });
    });
  }


  function removeFromWishlist() {
    $('#wishlist-container .wishlisted .wishlist').each(function () {
      $(this).off('click').on('click', function () {
        const handle = $(this).data('handle');
        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (dataUser.dataWishlist && Array.isArray(dataUser.dataWishlist)) {
          dataUser.dataWishlist = dataUser.dataWishlist.filter(item => {
            return getHandleFromUrl(item.url) !== handle;
          });

          localStorage.setItem("dataUser", JSON.stringify(dataUser));
          wishlist.load(); 
        }
      });
    });
  }

  function events() {
    clickColors();
    addcart();
    compare();
    S00601CartProduct.wishlist();
    S00601CartProduct.quickView();
    products.init();
  }

  wishlist.init();

  $(document).on('wishlist:reload', function() {
    wishlist.load();
  });
});
